import AutoInfracaoTransito from "./AutoInfracaoTransito";
import StatusAutoInfracaoTransito from "./StatusAutoInfracaoTransito";
import EmpresaFiscalizacao from "./EmpresaFiscalizacao";
import VigenciaLocalizacaoEquipamento from "./VigenciaLocalizacaoEquipamento";
import OrgaoAutuacao from "./OrgaoAutuacao";
import FormaAutuacao from "./FormaAutuacao";
import Agente from "./Agente";
import MunicipioInfracao from "./MunicipioInfracao";
import VigenciaCodigoInfracao from "./VigenciaCodigoInfracao";
import UnidadeMedida from "./UnidadeMedida";
import Usuario from "./Usuario";
import VigenciaVelocidadeRegulamentada from "./VigenciaVelocidadeRegulamentada";
import TipoVeiculo from "./TipoVeiculo";
import MarcaModeloVeiculo from "./MarcaModeloVeiculo";

class AitEletronico {
    constructor(
        {
            id = null,
            hash = null,
            auto_infracao_transito_id = null,
            status_auto_infracao_transito_id = null,
            protocolo_recebimento = null,
            nosso_numero_ait = null,
            checksum = null,
            empresa_fiscalizacao_id = null,
            vigencia_localizacao_equipamento_id = null,
            placa_veiculo = null,
            codigo_tipo_veiculo = null,
            codigo_marca_modelo_veiculo = null,
            data_hora_infracao = null,
            orgao_autuacao_id = null,
            forma_autuacao_id = null,
            agente_id = null,
            uf_infracao = null,
            municipio_infracao_id = null,
            vigencia_codigo_infracao_id = null,
            velocidade_aferida = null,
            velocidade_considerada = null,
            unidade_medida_id = null,
            infracao_json = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            vigencia_velocidade_regulamentada_id = null,
            tipo_veiculo_id = null,
            marca_modelo_veiculo_id = null,
            cancelar = false,
            endereco = {},

            //ORM
            auto_infracao_transito = {},
            status_auto_infracao_transito = {},
            empresa_fiscalizacao = {},
            vigencia_localizacao_equipamento = {},
            orgao_autuacao = {},
            forma_autuacao = {},
            agente = {},
            municipio_infracao = {},
            vigencia_codigo_infracao = {},
            unidade_medida = {},
            usuario = {},
            vigencia_velocidade_regulamentada = {},
            documento_ait_eletronico = [],
            tipo_veiculo = {},
            marca_modelo_veiculo = {},


        } = {}
    ) {
        this.id = id;
        this.hash = hash,
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.status_auto_infracao_transito_id = status_auto_infracao_transito_id;
        this.protocolo_recebimento = protocolo_recebimento;
        this.nosso_numero_ait = nosso_numero_ait;
        this.checksum = checksum;
        this.empresa_fiscalizacao_id = empresa_fiscalizacao_id;
        this.vigencia_localizacao_equipamento_id = vigencia_localizacao_equipamento_id;
        this.placa_veiculo = placa_veiculo;
        this.codigo_tipo_veiculo = codigo_tipo_veiculo;
        this.codigo_marca_modelo_veiculo = codigo_marca_modelo_veiculo;
        this.data_hora_infracao = data_hora_infracao;
        this.orgao_autuacao_id = orgao_autuacao_id;
        this.forma_autuacao_id = forma_autuacao_id;
        this.agente_id = agente_id;
        this.uf_infracao = uf_infracao;
        this.municipio_infracao_id = municipio_infracao_id;
        this.vigencia_codigo_infracao_id = vigencia_codigo_infracao_id;
        this.velocidade_aferida = velocidade_aferida ? parseFloat(velocidade_aferida) : null
        this.velocidade_considerada = velocidade_considerada ? parseFloat(velocidade_considerada) : null;
        this.unidade_medida_id = unidade_medida_id;
        this.infracao_json = infracao_json;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.vigencia_velocidade_regulamentada_id = vigencia_velocidade_regulamentada_id;
        this.tipo_veiculo_id = tipo_veiculo_id;
        this.marca_modelo_veiculo_id = marca_modelo_veiculo_id;
        this.cancelar = cancelar ? true : false;
        this.endereco = endereco;

        //ORM
        this.auto_infracao_transito = auto_infracao_transito ? new AutoInfracaoTransito(auto_infracao_transito) : new AutoInfracaoTransito();
        this.status_auto_infracao_transito = status_auto_infracao_transito ? new StatusAutoInfracaoTransito(status_auto_infracao_transito) : new StatusAutoInfracaoTransito();
        this.empresa_fiscalizacao = empresa_fiscalizacao ? new EmpresaFiscalizacao(empresa_fiscalizacao) : new EmpresaFiscalizacao();
        this.vigencia_localizacao_equipamento = vigencia_localizacao_equipamento ? new VigenciaLocalizacaoEquipamento(vigencia_localizacao_equipamento) : new VigenciaLocalizacaoEquipamento();
        this.orgao_autuacao = orgao_autuacao ? new OrgaoAutuacao(orgao_autuacao) : new OrgaoAutuacao();
        this.forma_autuacao = forma_autuacao ? new FormaAutuacao(forma_autuacao) : new FormaAutuacao();
        this.agente = agente ? new Agente(agente) : new Agente();
        this.municipio_infracao = municipio_infracao ? new MunicipioInfracao(municipio_infracao) : new MunicipioInfracao();
        this.vigencia_codigo_infracao = vigencia_codigo_infracao ? new VigenciaCodigoInfracao(vigencia_codigo_infracao) : new VigenciaCodigoInfracao();
        this.unidade_medida = unidade_medida ? new UnidadeMedida(unidade_medida) : new UnidadeMedida();
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.vigencia_velocidade_regulamentada = vigencia_velocidade_regulamentada ? new VigenciaVelocidadeRegulamentada(vigencia_velocidade_regulamentada) : new VigenciaVelocidadeRegulamentada();
        this.documento_ait_eletronico = documento_ait_eletronico;
        this.tipo_veiculo = tipo_veiculo ? new TipoVeiculo(tipo_veiculo) : new TipoVeiculo();
        this.marca_modelo_veiculo = marca_modelo_veiculo ? new MarcaModeloVeiculo(marca_modelo_veiculo) : new MarcaModeloVeiculo();
    }
}

export default AitEletronico;